import React, { useState } from 'react'
import styles from './style.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faDownLong, faLock, faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons';
import Payonline from '../../assets/images/icon/onlinepay.svg'
import ManualSearch from '../../Component/DatabaseSearch/Manual'
import AISearch from '../../Component/DatabaseSearch/AI'
import SearchHistory from '../../Component/DatabaseSearch/SearchHistory'
const Newfour = () => {
    const [activeTab, setActiveTab] = useState("manual");

    return (
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-md-8'>
                    <div className={`${styles['search-candidate']}`}>
                        <div className='row'>
                            <div className='col-md-12'>
                                <h3 className={`${styles['search-title']} text-center mb-4`}>Search Candidate</h3>
                                <hr />
                                <ul className="nav nav-pills nav-justified mb-4">
                                    <li className="nav-item">
                                        <button
                                            className={`nav-search nav-link ${activeTab === "manual" ? "active" : ""}`}
                                            onClick={() => setActiveTab("manual")}
                                        >
                                            Search manually
                                        </button>
                                    </li>
                                    <li className="nav-item">
                                        <button
                                            className={`nav-search nav-link ${activeTab === "ai" ? "active" : ""}`}
                                            onClick={() => setActiveTab("ai")}
                                        >
                                            ✨ Use AI
                                        </button>
                                    </li>
                                </ul>
                                <div>
                                    {activeTab === "manual" && (
                                        <ManualSearch />
                                    )}
                                    {activeTab === "ai" && (
                                        <AISearch />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className={`${styles['card-credits']} p-3 mb-3 shadow-sm`}>
                        <h5 className={`${styles['credits-title']} mb-3`}>How Database Credit Works?</h5>
                        <ul className="list-unstyled">
                            <li className="mb-2">
                                <span className={`${styles['lock-icon']} me-2`}>
                                    <FontAwesomeIcon icon={faLock} />
                                </span>
                                <span className={`${styles['text-profile']}`}>1 Profile Unlock = 1 Database Credit</span>
                            </li>
                            <li className="mb-2">
                                <span className={`${styles['download-icon']} me-2`}>
                                    <FontAwesomeIcon icon={faDownload} />
                                </span>
                                <span className={`${styles['text-profile']}`}>1 Excel Download = 2 Database Credits</span>
                            </li>
                        </ul>
                        <p className={`${styles['list-paragraph']}`}>
                            For already unlocked profiles, only 1 Database credit will be required
                            for Excel Download
                        </p>
                        <div className={`${styles['credit-box']} text-center p-3`}>
                            <div className={`${styles['plan-text']}`}>
                                <img src={Payonline} className='pe-2' />Explore Best Plans and Offers
                            </div>
                            <br />
                            <button className={`${styles['search-btn']} btn w-100`}>
                                Buy Credits<FontAwesomeIcon className='ps-2' icon={faLongArrowAltRight} />
                            </button>
                        </div>
                    </div>
                    <SearchHistory />
                </div>
            </div>
        </div>
    )
}

export default Newfour